import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { StudentSyncStatus } from '../../models/StudentSyncStatus';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-user-sync-status-icon',
  imports: [MatIcon, MatTooltip, TranslocoPipe],
  templateUrl: './user-sync-status-icon.component.html',
})
export class UserSyncStatusIconComponent {
  @Input() syncStatus: StudentSyncStatus;

  badgeIcons = {
    ['Terminated']: 'close',
    ['NotMatched']: 'question_mark',
    ['Synced']: 'check',
  };

  badgeColors = {
    ['Terminated']: 'bg-cancel',
    ['NotMatched']: 'bg-warning',
    ['Synced']: 'bg-success',
  };

  get tooltipKey() {
    return 'portal.hrisIntegration.syncStatusIconTooltip.' + this.syncStatus;
  }

  get badgeIcon() {
    return this.badgeIcons[this.syncStatus];
  }

  get badgeColor() {
    return this.badgeColors[this.syncStatus];
  }
}
